export default function FinalCTASection() {
  return (
    <section className="relative py-16 md:py-20 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#1B4D3E] via-[#1a5c3a] to-[#C8A951]"></div>
      <div className="absolute inset-0 bg-black/20"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-white mb-6">
          Your Renewed Passport — Faster Than You Thought Possible
        </h2>

        <p className="text-green-100/90 max-w-3xl mx-auto mb-10 text-base md:text-lg leading-relaxed">
          Standard government processing takes 6–10 weeks including mailing time. Fast Passport Center gets it done in 3–9 business days. No office visit. No passport agency trip. No driving to Chicago, Miami, or San Francisco. Just mail us your documents — our registered couriers handle everything else and ship your renewed passport back overnight.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <a
            href="https://fastpassportcenter.com/checkout/?passport=passport-renewal"
            className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-4 bg-[#C8A951] hover:bg-[#b8942e] text-[#1B4D3E] font-bold text-base md:text-lg rounded-md transition-colors cursor-pointer"
          >
            <i className="ri-passport-line text-xl"></i>
            Renew My Passport Now
          </a>
          <a
            href="tel:8772530084"
            className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-4 border-2 border-white/40 hover:border-white hover:bg-white/10 text-white font-semibold text-base md:text-lg rounded-md transition-colors cursor-pointer"
          >
            <i className="ri-phone-fill text-xl"></i>
            Call 877-253-0084
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-white/70 text-xs md:text-sm">
          <span className="whitespace-nowrap">Registered State Dept. Courier</span>
          <span className="hidden sm:inline text-white/40">|</span>
          <span className="whitespace-nowrap">A+ BBB</span>
          <span className="hidden sm:inline text-white/40">|</span>
          <span className="whitespace-nowrap">No Office Visit</span>
          <span className="hidden sm:inline text-white/40">|</span>
          <span className="whitespace-nowrap">Overnight FedEx Return</span>
          <span className="hidden sm:inline text-white/40">|</span>
          <span className="whitespace-nowrap">20+ Years</span>
        </div>
      </div>
    </section>
  );
}